import {useState} from "react";
import {get_nested} from "../../../services/JsonHandler";
import {isNullOrUndefined} from "../../../services/Validator";
import SystemCustomCheckBox from "../../others/SystemCustomCheckBox";
import {
    isSubthemeSelected, renderSubthemeStyle, renderSubthemeThemeStyle
} from "../../../controllers/flashScreens/parameterStepScreen/ParameterSubthemeItemController";
import {capitalizeFirst} from "../../../helpers/StringHelper";
import SystemIcon from "../../icons/SystemIcon";
import SystemHorizontalStarDivider from "../../dividers/courses/flash/SystemHorizontalStarDivider";

export default function CoursesSubthemeItem({ index, total, subtheme, selectSubtheme, selectedSubtheme }) {
    // Used in CoursesSubthemesList to display one single
    // levelA item

    // PROPERTIES
    const [isHovered, setIsHovered] = useState(false)
    const subthemeName = get_nested(['name'], subtheme, null)
    const subthemeThemeName = get_nested(['subthemeTheme', 'name'], subtheme, null)

    // BUILD
    if (isNullOrUndefined(subtheme) || isNullOrUndefined(subthemeName))
        return null
    return (
        <div className="w-full flex flex-col">
            <div className={`w-full flex justify-between items-center cursor-pointer pl-[16px] pr-[20px] py-[12px]`}
                 onMouseEnter={() => setIsHovered(true)}
                 onMouseLeave={() => setIsHovered(false)}
                 onClick={() => selectSubtheme(subtheme)}>
                <div className={"flex justify-start items-start space-x-[8px]"}>
                    <SystemCustomCheckBox isChecked={isSubthemeSelected(subtheme, selectedSubtheme)} />
                    <div className={"flex flex-col font-medium"}>
                        <span className={`text-[16px] ${renderSubthemeStyle(subtheme, selectedSubtheme, isHovered)}`}>
                            {capitalizeFirst(subthemeName)}
                        </span>
                        <span className={`text-[14px] ${renderSubthemeThemeStyle(subtheme, selectedSubtheme, isHovered)}`}>
                            {capitalizeFirst(subthemeThemeName)}
                        </span>
                    </div>
                </div>
                <SystemIcon icon={"chevron_right"}
                            isHovered={isHovered} />
            </div>
            {/** BOTTOM DIVIDER IF NECESSARY */}
            {index === (total - 1)
                ? null
                : <SystemHorizontalStarDivider />
            }
        </div>
    );
}